export default __webpack_public_path__ + "88238be1adb06723111b36e3509ff2ea.svg";